
import { Component, Vue } from 'vue-property-decorator';
// import htmlSanitize from 'spa-ionata-admin/lib/services/htmlSanitize';
import { extNavModule } from '../store';

@Component({ components: {} })
export default class extends Vue {
  get footerHtml() {
    if (!extNavModule.footer) {
      return undefined;
    }
    // return htmlSanitize(extNavModule.footer);
    return extNavModule.footer;
  }

  async mounted() {
    extNavModule.fetchIfNeeded();
  }
}
